// services/ecosystem/queries.ts

import { useQuery } from '@tanstack/react-query'
import { apiGetAllNewsTypes, apiGetAllNewsTypesChild } from './api'
import { GetAllNewsTypesResponse, EcosystemItem } from './type'

const KEYWORD_ECOSYSTEM = process.env.NEXT_PUBLIC_KEYWORD_ECOSYSTEM as string

const KEYWORD_ALL = process.env.NEXT_PUBLIC_KEYWORD_ALL as string

const ECOSYSTEM_PAYLOAD = {
    keywords: KEYWORD_ECOSYSTEM,
    isMenu: '',
    isPublic: '',
    page: 1,
    pageSize: 50,
} as const

const NEWS_PAYLOAD = {
    keywords: KEYWORD_ALL,
    isMenu: '',
    isPublic: '',
    page: 1,
    pageSize: 50,
} as const

export const useGetEcosystemGroupsQuery = () => {
    return useQuery<EcosystemItem[]>({
        queryKey: ['ecosystem', 'groups'],
        queryFn: async () => {
            const response = await apiGetAllNewsTypes(ECOSYSTEM_PAYLOAD)
            if (!response?.isOK || !response.result?.items) {
                return []
            }
            return response.result.items
        },
        select: (items) => {
            return items.sort((a, b) => a.sort - b.sort)
        },
        staleTime: 30 * 60 * 1000,
    })
}

export const useGetNewsGroupsQuery = () => {
    return useQuery<EcosystemItem | null>({
        queryKey: ['news', 'groups'],
        queryFn: async () => {
            const response = await apiGetAllNewsTypesChild(NEWS_PAYLOAD)

            if (!response?.isOK || !response.result) {
                return null
            }

            return response.result
        },
        staleTime: 30 * 60 * 1000,
    })
}